export const SET_AUTHENTICATED = 'SET_AUTHENTICATED';
export const SET_WRONG_EMAIL_OR_PASSWORD = 'SET_WRONG_EMAIL_OR_PASSWORD';
export const GET_ROLES = 'GET_ROLES';
export const SET_ROLES = 'SET_ROLES';
export const LOGOUT = 'LOGOUT';
export const SAVE_USER_CREDENTIALS_FOR_MFA = 'SAVE_USER_CREDENTIALS_FOR_MFA';
export const CLEAR_ERROR = 'CLEAR_ERROR';
export const MFA_LOGIN_ERROR = 'MFA_LOGIN_ERROR';